PJQ.views.files.FileSelector = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.FILES, 'File-Selector'),
		subTemplates: {
			file: new PJQ.templating.Template(PJQ.constants.modules.FILES, 'Selector-File')
		},
		header: 'Select folders to attach',
		confirmButton: 'Attach',
		project: null,
		isDeferred: true,
		minWidth: 400,
		maxWidth: 800,
		fitHeight: true,
		sortBy: 'name',
		foldersOnly: false,
		sortDirection: 'asc',
		selectedAttachmentIds: [],
		selectedEntryIds: [],
		selectedDrawingIds: [],
		disabledAttachmentIds: [],
		mode: null,
		onSave: _.noop
	},
	defaultEvents: {
		'click .attachment-link': 'attachmentClicked',
		'click .attachment-folder': 'folderClicked',
		'click .col-label': 'changeSort',
		'change .input-select-attachment': 'attachmentChecked',
		'click .btn-cancel': 'removeModal',
		'click .btn-save': 'save'
	},
	beforeModalCreated: function () {
		if (_.size(this.options.selectedAttachmentIds) > 0) {
			this.selectedAttachmentIds = this.options.selectedAttachmentIds;
		}
		else {
			this.selectedAttachmentIds = [];
		}

		if (this.options.project != null) {
			let mode = this.options.mode ? this.options.mode.toUpperCase() : 'ALL',
				opts = {
					isPrivate: mode == null || mode === 'ALL' || mode === 'PRIVATE',
					isShared: mode == null || mode === 'ALL' || mode === 'SHARED'
				}

			this.options.project.fetchAttachments(opts, _.bind(function (attachments) {
				this.collection = attachments;

				let selAtt = [];
				_.each(this.options.selectedEntryIds, function (id) {
					let atts = _.filter(this.collection.models, function (att) {
						return att.get('entryId') === id;
					});
					if (_.size(atts) > 0) {
						selAtt.push(..._.map(atts, function(att){
							return att.cid;
						}));
					}
				}, this);
				_.each(this.options.selectedDrawingIds, function (id) {
					let atts = _.filter(this.collection.models, function (att) {
						return att.get('drawingId') === id;
					});
					if (_.size(atts) > 0) {
						selAtt.push(..._.map(atts, function(att){
							return att.cid;
						}));
					}
				}, this);
				this.selectedAttachmentIds = _.union(selAtt, this.selectedAttachmentIds);

				this.listenTo(this.collection, 'update fetch', this.render);
				this.render();
			}, this));
		}
		else {
			if (this.options.collection != null) {
				this.collection = this.options.collection;
				this.listenTo(this.collection, 'update fetch', this.render);
			}
			else {
				this.collection = this.options.collection != null ? this.options.collection : new PJQ.collections.files.Files();
				this.listenTo(this.collection, 'update fetch', this.render);
				this.collection.fetch();
			}
		}
	},
	renderData: function () {
		return {
			collection: this.collection,
			isAdmin: this.options.isAdmin,
			options: this.options
		};
	},
	afterRender: function () {
		if (this.collection != null && this.collection.isFetched) {
			this.renderAttachments();
		}
	},
	changeSort: function (e) {
		let $target = $(e.currentTarget),
			newSort = $target.data('attr');
		if (newSort !== this.options.sortBy || this.options.sortDirection === 'desc') {
			this.options.sortDirection = 'asc';
		}
		else {
			this.options.sortDirection = 'desc';
		}
		this.options.sortBy = newSort;

		this.$('.fa-long-arrow-up,.fa-long-arrow-down').removeClass('active');
		if (this.options.sortDirection === 'asc') {
			$target.parent('div').find('.fa-long-arrow-down').addClass('active');
		}
		else {
			$target.parent('div').find('.fa-long-arrow-up').addClass('active');
		}

		this.renderAttachments();
	},
	sortAttachments: function (attachments) {
		let self = this,
			result = attachments.sort(function (a, b) {
				if (self.options.sortBy === "size") {
					return a.getSize() > b.getSize() ? 1 : -1;
				}
				else if (self.options.sortBy === "modifiedOn") {
					return PJQ.helpers.sortHelpers.sortAlphaNum(a.get('modifiedOn'), b.get('modifiedOn'));
				}
				else {
					return PJQ.helpers.sortHelpers.sortAlphaNum(a.get('name'), b.get('name'));
				}
			});
		return this.options.sortDirection === 'desc' ? result.reverse() : result;
	},
	renderAttachments: function () {
		let $container = this.$('.attachments-nav'),
			expandedFolders = [],
			rootAttachments = _.filter(this.collection.models, function (attachment) {
				return attachment.getParentFolder() == null;
			});

		if (_.size(rootAttachments) === 1 && rootAttachments[0].get('isFolder') && rootAttachments[0].getFolderAttachments() > 0) {
			rootAttachments = rootAttachments[0].getFolderAttachments();
		}

		rootAttachments = this.sortAttachments(rootAttachments);

		$container.find('.attachment-folder.expanded').each(function () {
			expandedFolders.push($(this).data('cid'));
		});
		if (_.size(rootAttachments) > 0) {
			$container.empty();
			_.each(rootAttachments, function (attachment) {
				if (this.options.foldersOnly && !attachment.get('isFolder')) {
					return;
				}

				this.renderAttachment($container, attachment, expandedFolders);
			}, this);
		}
	},
	renderAttachment: function ($container, attachment, expandedFolders, depth = 0) {
		this.renderSubTemplate(true, this.options.subTemplates.file, $container, {
			model: attachment,
			foldersOnly: this.options.foldersOnly,
			isSelected: this.selectedAttachmentIds.indexOf(attachment.cid) !== -1,
			isExpanded: expandedFolders.indexOf(attachment.cid) !== -1,
			isDisabled: (this.options.foldersOnly && !attachment.get('isFolder')) || this.options.disabledAttachmentIds.indexOf(attachment.get('entryId')) !== -1,
			depth: depth,
		}, _.bind(function ($folder) {
			if (attachment.get('isFolder')) {
				depth++;
				let folderAttachments = this.sortAttachments(attachment.getFolderAttachments()),
					$files = $folder.find('.attachment-files').first();
				_.each(folderAttachments, function (folderAttachment) {
					this.renderAttachment($files, folderAttachment, expandedFolders, depth);
				}, this);
			}
		}, this));
	},
	getAttachmentElement: function (attachment) {
		return this.$('.attachments-nav').find('.attachment[data-cid="' + attachment.cid + '"]');
	},
	attachmentClicked: function (e) {
		let $target = $(e.target),
			$attachment = $target.closest('.attachment'),
			attachment = this.collection.get($attachment.data('cid'));
		if (!attachment.get('isFolder')) {
			if(PJQ.app.session.project.orderSettings.get('downloadPerFileFee') > 0 && PJQ.app.session.get('masterUserId') !== PJQ.app.session.project.get('masterUserId')){
				new PJQ.views.files.FileViewer({
					model: attachment,
					isDisableDownload: true
				});
			}
			else{
				attachment.download();
			}
		}
	},
	folderClicked: function (e) {
		let $target = $(e.target);
		if (!$target.hasClass('dropdown-toggle') && !$target.is('input')) {
			this.expandFolder($(e.currentTarget));
		}
	},
	attachmentChecked: function (e) {
		let $checkbox = $(e.currentTarget),
			$attachment = $checkbox.closest('.attachment'),
			attachment = this.collection.get($attachment.data('cid')),
			isChecked = $(e.currentTarget).prop('checked'),
			attachmentIds = [attachment.cid];

		if (attachment.get('isFolder')) {
			attachmentIds.push(..._.map(attachment.getFolderAttachments(true), function (folderAttachment) {
				return folderAttachment.cid;
			}));
			$attachment.siblings('.attachment-files-outer').find('.input-select-attachment').prop('checked', isChecked);
		}

		if (isChecked) {
			this.selectedAttachmentIds.push(...attachmentIds);
		}
		else {
			this.selectedAttachmentIds = _.difference(this.selectedAttachmentIds, attachmentIds);
			this.$('.input-select-all').prop('checked', false);
		}

		this.selectedAttachmentsChanged();
	},
	selectedAttachmentsChanged: function () {
		let selectedCount = _.size(this.selectedAttachmentIds);
		this.$('.btn-download-selected,.btn-file-actions').prop('disabled', selectedCount === 0);

		if (!this.options.isDeferred) {
			this.$('.ct-selected-attachments').html(selectedCount);
		}
	},
	expandFolder: function ($folder, expandOnly = false) {
		let $attachments = $folder.siblings('.attachment-files-outer'),
			isExpanded = $attachments.is(':visible');
		let folder = this.collection.get($folder.data('cid')),
			fnRender = _.bind(function () {
				if (!$attachments.hasClass('fetched')) {
					$attachments.addClass('fetched');
					let $files = $attachments.find('.attachment-files').first();
					if (this.options.project == null) {
						let folderAttachments = this.sortAttachments(folder.getFolderAttachments());
						_.each(folderAttachments, _.bind(function (attachment) {
							this.renderAttachment($files, attachment, [], attachment.getDepth());
						}, this));
					}
				}
				if (!isExpanded) {
					$folder.addClass('expanded');
					$attachments.animateCSS('slideDown');
				}
				else if (!expandOnly) {
					$attachments.animateCSS('slideUp', function () {
						$folder.css({
							background: ''
						});
					});
					$folder.removeClass('expanded');
				}
			}, this);

		if (this.options.project == null) {
			if (folder.isFetched) {
				fnRender();
			}
			else {
				folder.fetchFolderAttachments(null, _.bind(function (files) {
					if (this.selectedAttachmentIds.indexOf(folder.cid) !== -1) {
						_.each(files, _.bind(function (file) {
							if (this.selectedAttachmentIds.indexOf(file.cid) === -1) {
								this.selectedAttachmentIds.push(file.cid)
							}
						}, this));
					}
					fnRender();
				}, this));
			}
		}
		else {
			fnRender();
		}
	},
	save: function () {
		if (typeof this.options.onSave === 'function') {
			this.options.onSave(this.collection.get(this.selectedAttachmentIds));
		}
		this.removeModal();
	}
});
